import React, { useState, useEffect } from "react";
import axios from "axios";
import { Line } from 'react-chartjs-2';
import { Box, Typography, CircularProgress } from '@mui/material';
import config from "../config.js"

const SalesChart4 = () => {
  const [salesData, setSalesData] = useState([]);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/SalesworkbookToJson`);
        setSalesData(response.data.data.Calcs);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, []);

  const prepareLineChartData = () => {
    const labels = salesData.map(item => item.Salesman);
    const sales = salesData.map(item => item.Sales);
    const revenue = salesData.map(item => item.Revenue);

    return {
      labels: labels,
      datasets: [
        {
          label: 'Sales',
          data: sales,
          fill: false,
          borderColor: 'rgba(255, 99, 132, 1)',
          tension: 0.1
        },
        {
          label: 'Revenue',
          data: revenue,
          fill: false,
          borderColor: 'rgba(54, 162, 235, 1)',
          tension: 0.1
        }
      ]
    };
  };

  return (
    <div>
      <Box>
        {salesData.length === 0 ? (
          <CircularProgress />
        ) : (
          <Box>
           
            <div>
              <Typography variant="h6">Line Chart</Typography>
              <Line
                data={prepareLineChartData()}
                options={{
                  scales: {
                    y: {
                      beginAtZero: true,
                      title: {
                        display: true,
                        text: 'Amount'
                      }
                    },
                    x: {
                      title: {
                        display: true,
                        text: 'Salesman'
                      }
                    }
                  }
                }}
              />
            </div>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default SalesChart4;

